import { render, staticRenderFns } from "./LiveShopPopUp.vue?vue&type=template&id=35af2506&"
import script from "./LiveShopPopUp.vue?vue&type=script&lang=js&"
export * from "./LiveShopPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports